export default {
  DEBIT_ACTIVITY_LIST_REQUEST: 'APP/DEBIT_ACTIVITY/DEBIT_ACTIVITY_LIST_REQUEST',
  DEBIT_ACTIVITY_LIST_SUCCESS: 'APP/DEBIT_ACTIVITY/DEBIT_ACTIVITY_LIST_SUCCESS',
  DEBIT_ACTIVITY_LIST_ERROR: 'APP/DEBIT_ACTIVITY/DEBIT_ACTIVITY_LIST_ERROR',
};
